//import { NotificationListService } from "@/services/notifications/NotificationListService";
import { INotificationListService } from "@/services/notifications/INotificationListService";
import { NotificationListService } from "@/services/notifications/NotificationListService";
import { Container } from "inversify";
import { IoCTypes } from "./IoCTypes";

export const bindNotification = (container: Container) => {
    container.bind<INotificationListService>(IoCTypes.NotificationListService)
        .to(NotificationListService)
}